// Testi verificati sulla dashboard il 2026-10-16 (vedi piano guide operative).
export default {
  slug: 'documenti',
  module: 'documents',
  title: 'I documenti',
  tile: 'Organizza le cartelle, carica file e fai firmare i dipendenti.',
  minutes: 4,
  publishedAt: '2026-10-26T09:00:00.000Z',
  moduleLabel: 'Apri i documenti',
  modulePath: 'documents',
  brief: {
    purpose: "Archiviare i documenti dell'azienda e scambiarli con lo studio paghe.",
    who: "Chi in azienda tiene l'archivio e dialoga con lo studio.",
    when: 'Ogni volta che devi conservare, condividere o far firmare un file.',
  },
  steps: [
    {
      title: 'Conosci le tre cartelle',
      text: 'In Documenti trovi tre cartelle principali, ognuna con un compito preciso.',
      screen: 'documenti-1',
      notes: [
        'AZIENDA: conservi i documenti aziendali',
        'COMUNICA ALLO STUDIO: invii allo studio ciò che serve per le paghe',
        'DOCUMENTI PAGHE: consulti e scarichi ciò che lo studio ha preparato',
      ],
    },
    {
      title: 'Carica un documento',
      text: 'Entra in AZIENDA o COMUNICA ALLO STUDIO e premi «Carica documento». Con «Crea Cartella» organizzi i file come preferisci.',
      screen: 'documenti-2',
      notes: ['Crea una sottocartella, per esempio «Contratti 2026»', 'Trascina i file o sceglili dal computer'],
      tip: 'Per far firmare un file a una persona, caricalo dalla sua scheda (sezione Documenti) e spunta «Documento da firmare».',
    },
    {
      title: 'Trova un file in un attimo',
      text: "Non ricordi dove l'hai messo? Scrivi una parola del nome in «Cerca documenti».",
      screen: 'documenti-3',
      notes: ['Scrivi una parte del nome del file e scegli tra i risultati'],
    },
    {
      title: 'Invia e fai firmare',
      text: 'Da Invii e firme premi «Prepara documento»: in cinque passaggi (Dati, Documento, Destinatari, Allegati, Invio) prepari il documento e lo invii a uno o più dipendenti. In «Registro invii» segui come procede.',
      screen: 'documenti-4',
      notes: ['Registro invii: data, documento ed esito di ogni invio', 'Prepara documento: dati, documento, destinatari, allegati, invio'],
    },
  ],
  faq: [
    {
      question: 'Perché non posso caricare file in DOCUMENTI PAGHE?',
      answer: 'È la cartella in cui lo studio paghe mette i documenti elaborati: tu puoi consultarli e scaricarli.',
    },
    {
      question: 'Il dipendente viene avvisato quando carico un suo documento?',
      answer: 'Se il documento non è da firmare, spunta «Notifica dipendente» al caricamento.',
    },
  ],
};
